import React, { useState, useEffect } from "react";
import { Form, Input, Upload, Button, Row, Col, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { createPersonal, updatePersonal } from "../../http/personalAPI";
import { $host } from "../../http";

const { TextArea } = Input;

const PersonalForm = ({ mode = "add", person = null, onSuccess }) => {
    const [fileList, setFileList] = useState([]);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [form] = Form.useForm();

    // Prefill form when editing
    useEffect(() => {
        if (person) {
            form.setFieldsValue({
                fullNameAM: person.fullNameAM,
                fullNameEN: person.fullNameEN,
                fullNameRU: person.fullNameRU,
                positionAM: person.positionAM,
                positionEN: person.positionEN,
                positionRU: person.positionRU,
            });

            if (person.img_main) {
                setPreviewUrl(
                    $host.defaults.baseURL + `/photos/personal/${person.img_main}`
                );
            }
        }
    }, [person, form]);

    const beforeUpload = (file) => {
        const isImage =
            file.type === "image/jpeg" ||
            file.type === "image/png" ||
            file.type === "image/jpg";

        if (!isImage) {
            message.error("Only JPG/PNG images allowed.");
            return Upload.LIST_IGNORE;
        }

        if (file.size / 1024 / 1024 > 5) {
            message.error("Image must be smaller than 5MB!");
            return Upload.LIST_IGNORE;
        }

        setPreviewUrl(URL.createObjectURL(file));
        return false;
    };

    const handleImageChange = ({ fileList }) => {
        setFileList(fileList);
    };

    const handleSubmit = async (values) => {
        const formData = new FormData();
        Object.entries(values).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
                formData.append(key, value);
            }
        });

        if (fileList.length > 0 && fileList[0].originFileObj) {
            formData.append("img_main", fileList[0].originFileObj);
        }

        try {
            if (mode === "add") {
                await createPersonal(formData);
                message.success("Personnel created!");
            } else {
                await updatePersonal(person.id, formData);
                message.success("Personnel updated!");
            }

            form.resetFields();
            setFileList([]);
            setPreviewUrl(null);
            onSuccess?.();
        } catch (err) {
            console.error(err);
            message.error("Error saving personnel.");
        }
    };

    return (
        <Form layout="vertical" form={form} onFinish={handleSubmit}>
            <h3>{mode === "add" ? "Add Personnel" : "Update Personnel"}</h3>

            <Row gutter={16}>
                <Col span={8}>
                    <Form.Item
                        name="fullNameAM"
                        label="Full Name (AM)"
                        rules={[{ required: true }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item name="positionAM" label="Position (AM)">
                        <TextArea rows={2} />
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item
                        name="fullNameEN"
                        label="Full Name (EN)"
                        rules={[{ required: true }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item name="positionEN" label="Position (EN)">
                        <TextArea rows={2} />
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item
                        name="fullNameRU"
                        label="Full Name (RU)"
                        rules={[{ required: true }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item name="positionRU" label="Position (RU)">
                        <TextArea rows={2} />
                    </Form.Item>
                </Col>
            </Row>

            <Form.Item label="Image">
                <Upload
                    fileList={fileList}
                    beforeUpload={beforeUpload}
                    onChange={handleImageChange}
                    listType="picture"
                    maxCount={1}
                >
                    <Button icon={<UploadOutlined />}>Upload Image</Button>
                </Upload>

                {previewUrl && (
                    <img
                        src={previewUrl}
                        alt="preview"
                        style={{
                            width: 140,
                            marginTop: 10,
                            borderRadius: 8,
                            border: "1px solid #ddd",
                        }}
                    />
                )}
            </Form.Item>

            <Form.Item>
                <Button type="primary" htmlType="submit" block>
                    {mode === "add" ? "Create Personnel" : "Update Personnel"}
                </Button>
            </Form.Item>
        </Form>
    );
};

export default PersonalForm;
